import React from 'react'

import { AxiosError } from 'axios'

import { bottles } from 'src/axious/bottles'
import { useActiveFilters } from 'src/zustand/stores/filters.store'

import { Bottle, Filters, NoBottles } from '../../components'
import { useFilter } from '../../hooks'

interface Props {
  className?: string
}

const LotteryBottles: React.FC<Props> = ({ className }) => {
  const [isLoadingData, setIsLoadingData] = React.useState<boolean>(true)
  const { filteredBottles, filter: filterForBottles, passListOfBottles } = useFilter()
  const resetFilters = useActiveFilters((state) => state.resetFilters)

  const updateData = () => {
    resetFilters()
    setIsLoadingData(true)
  }

  React.useEffect(() => {
    const getBottles = async () => {
      try {
        const res = await bottles('get', '?status=active')
        passListOfBottles(res)
        setIsLoadingData(false)
      } catch (err) {
        if (err instanceof AxiosError) {
          if (err.response) {
            console.log('Server error:', err.response.status, err.response.data)
          } else if (err.request) {
            console.log('Network error:', err.request)
          } else {
            console.log('Unexpected error:', err.message)
          }
        } else {
          console.log('Non-Axios error:', err)
        }
      }
    }

    getBottles()
  }, [isLoadingData])

  return (
    <>
      <Filters filter={filterForBottles} />

      {isLoadingData && <NoBottles variant='no_participations' />}

      {!isLoadingData && (
        <>
          {filteredBottles.length > 0 ? (
            <div className={className}>
              {filteredBottles.map((bottle) => (
                <Bottle key={bottle.id} {...bottle} />
              ))}
            </div>
          ) : (
            <NoBottles variant='nothing' resetFilters={updateData} />
          )}
        </>
      )}
    </>
  )
}

export default LotteryBottles
